import { render } from "./ParityGap.vue?vue&type=template&id=32a278d4&scoped=true"
import script from "./ParityGap.vue?vue&type=script&lang=js"
export * from "./ParityGap.vue?vue&type=script&lang=js"

import "./ParityGap.vue?vue&type=style&index=0&id=32a278d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a278d4"]])

export default __exports__